package com.rainbowclubs.rainbow.data.cache


import com.russhwolf.settings.Settings

class ClubCache(
    private val settings: Settings,
) {
    var selectedClub: String?
        get() = settings.getStringOrNull(CLUB_ID)?.takeIf { it.isNotBlank() }
        set(value) {
            val clubId = value?.takeIf { it.isNotBlank() }
            if (clubId == null) {
                settings.remove(CLUB_ID)
            } else {
                settings.putString(CLUB_ID, clubId)
            }
        }

    fun clear() {
        settings.remove(CLUB_ID)
    }

    fun hasSelectedClub(): Boolean = !selectedClub.isNullOrBlank()

    companion object {
        private const val CLUB_ID = "selected_club_id"
    }
}
